"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render_data_list = void 0;
var React = require("react");
var react_dom_1 = require("react-dom");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var render_data_list = function (html_container, project_id, DataListApp, data_list) {
    var container = document.getElementById(html_container);
    if (container) {
        App_1.store.context.set(new contexts_1.ProjectContext(project_id));
        if (data_list) {
            data_list.fetchData(window.location.search).then(function () {
                data_list.filter_state.fetchData();
                data_list.settings.fetchData();
                data_list.bulk_menu_state.fetchData();
            });
        }
        (0, react_dom_1.render)(React.createElement(DataListApp, null), container);
    }
};
exports.render_data_list = render_data_list;
